import React, { Fragment } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import CheckCircleTwoTone from '@ant-design/icons/CheckCircleTwoTone';
import InfoCircleOutlined from '@ant-design/icons/InfoCircleOutlined';
import FactAboutWeatherProtection from '../../../../organisms/factaboutweatherprotection/FactAboutWeatherProtection';
import SelfControlWeatherProtectionContainer from '../../../../organisms/selfcontrolweatherprotectioncontainer/SelfControlWeatherProtectionContainer';
import type { FactsAboutWeatherProtectionDto as FactsAboutWeatherProtection } from '../../../../../api/generated/model/factsAboutWeatherProtectionDto';
import type { SelfControlWeatherProtectionContainerDto as SelfControlWeatherProtectionContainerModel } from '../../../../../api/generated/model/selfControlWeatherProtectionContainerDto';
import AsyncStbButton from '../../../../atoms/button/AsyncStbButton';
import StbButton from '../../../../atoms/button/StbButton';

const completionIcon = (
    <CheckCircleTwoTone
        twoToneColor="#52c41a"
        style={{ fontSize: '25px', marginLeft: '10px' }}
    />
);

const weatherSigningInformation = (
    <Tooltip id="weather-signing-information">
        På väderskyddsprojekt skickas e-post när både egenkontrollen för ställning och egenkontrollen för väderskydd är signerade.
    </Tooltip>
);

interface WeatherProtectionAccordionItemsProps {
    projectId: number;
    factsAboutWeatherProtectionData: FactsAboutWeatherProtection | undefined | null;
    factsAboutWeatherProtectionCompletionStatus: boolean;
    setFactsAboutWeatherProtectionData: React.Dispatch<React.SetStateAction<FactsAboutWeatherProtection | null | undefined>>;
    selfControlWeatherProtectionData: SelfControlWeatherProtectionContainerModel | undefined | null;
    selfControlWeatherProtectionCompletionStatus: boolean;
    setSelfControlWeatherProtectionData: React.Dispatch<React.SetStateAction<SelfControlWeatherProtectionContainerModel | null | undefined>>;
    workerView: boolean;
    onSign: () => Promise<void>;
}

const WeatherProtectionAccordionItems: React.FC<WeatherProtectionAccordionItemsProps> = ({
    projectId,
    factsAboutWeatherProtectionData,
    factsAboutWeatherProtectionCompletionStatus,
    setFactsAboutWeatherProtectionData,
    selfControlWeatherProtectionData,
    selfControlWeatherProtectionCompletionStatus,
    setSelfControlWeatherProtectionData,
    workerView,
    onSign,
}) => {
    return (
        <Fragment>
            {factsAboutWeatherProtectionData &&
                <Accordion.Item className='accordion-item shadow fw-bold' eventKey="1">
                    <Accordion.Header className={workerView ? "disabled-header" : ""}>
                        Fakta om Väderskydd
                        {factsAboutWeatherProtectionCompletionStatus ? completionIcon : null}
                    </Accordion.Header>
                    <Accordion.Body className={workerView ? "disabled-body" : ""}>
                        <fieldset disabled={workerView} className="border-0 m-0 p-0 w-100">
                            <FactAboutWeatherProtection
                                factsAboutWeatherProtection={factsAboutWeatherProtectionData}
                                setFactsAboutWeatherProtection={setFactsAboutWeatherProtectionData}
                                onUpdate={(newObject) => setFactsAboutWeatherProtectionData(newObject)}
                            />
                        </fieldset>
                    </Accordion.Body>
                </Accordion.Item>
            }
            {selfControlWeatherProtectionData &&
                <Accordion.Item className='accordion-item shadow fw-bold' eventKey="2">
                    <Accordion.Header>
                        Egenkontroll Väderskydd
                        {selfControlWeatherProtectionCompletionStatus ? completionIcon : null}
                    </Accordion.Header>
                    <Accordion.Body>
                        <SelfControlWeatherProtectionContainer
                            projectId={projectId}
                            selfControlWeatherProtectionContainer={selfControlWeatherProtectionData}
                            setSelfControlWeatherProtectionContainer={setSelfControlWeatherProtectionData}
                            onUpdate={() => undefined}
                        />
                        <div className="stb-action-bar">
                            <OverlayTrigger
                                placement="top"
                                overlay={weatherSigningInformation}
                            >
                                <StbButton type="button" variant="ghost" icon aria-label="Information om signering">
                                    <InfoCircleOutlined aria-hidden="true" />
                                </StbButton>
                            </OverlayTrigger>
                            <AsyncStbButton type="button" variant="primary" onClick={onSign}>
                                Signera egenkontroll
                            </AsyncStbButton>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            }
        </Fragment>
    );
};

export default WeatherProtectionAccordionItems;
